/**
 * Component base class
 *
 * @module components
 */
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  /*
   * Component base class.
   */
  class Component {
    /**
     * Constructor
     * 
     * @param {HTMLElement} element 
     * @param {Object} [options]
     */
    constructor(element, options = {}) {
      this.name = 'component';
      this.initializedClass = 'initialized';
      this.options = options;
      this.element = $(element);
    }
    
    /**
     * Component main init
     */
    init() {
      // to be overrided
    }

    isMobile() {
      this.mobileFlag = this.mobileFlag ? this.mobileFlag : this.getMobileFlag();

      // if the mobileFlag element is absent, consider is as mobile
      if (!this.mobileFlag || !this.mobileFlag.length) {
        return false;
      }

      return !(this.mobileFlag.css('display') === 'none');
    }

    getMobileFlag() {
      return this._getMobileFlag(this.element);
    }

    _getMobileFlag(parent) {
      const componentSelector = `${this.constructor.selectors.parentComponentSelector}, body`;
      let p, el, elFlag;
        
      // find all flags inside parent
      el = $(this.constructor.selectors.mobileFlag, parent);

      if (el.length) {
        // look for flag that is NOT inside another components
        el.each((idx, _el) => {
          _el = $(_el);

          while (true) {
            p = _el.parent();

            // no parent, this should not happen
            if (!p.length) {
              break;
            }

            // p is the context element, use it
            if (p[0] === parent[0]) {
              elFlag = _el;
              break;
            }

            // p is inside another component inside the context element, don't use
            if (p.is(componentSelector)) {
              break;
            }

            _el = p;
          }

          if (elFlag) {
            return false;
          }
        });
      }

      // if no flag was found, traverse up and look again
      if (!elFlag) {
        const _parent = parent.parent().closest(componentSelector);
        if (_parent.length) {
          return this._getMobileFlag(_parent);
        }
        
        return undefined;
      }

      return elFlag;
    }

    /**
     * Get parent component.
     * 
     * @return {HTMLElement}
     */
    getParentComponent() {
      const componentSelector = this.constructor.selectors.parentComponentSelector;
      const p = this.element.parent().closest(componentSelector);
      
      return p.length ? p : null;
    }

    /**
     * Write log message to console
     * 
     * @param  {...any}
     */
    log(...args) {
      args.unshift(`${this.name}: `);
      // eslint-disable-next-line no-console
      console.log.apply(console, args);
    }

    /**
     * Write error message to console
     * 
     * @param  {...any}
     */
    logError(...args) {
      args.unshift(`${this.name}: `);
      // eslint-disable-next-line no-console
      console.error.apply(null, args);
    }

    /**
     * Write warning message to console
     * 
     * @param  {...any}
     */
    logWarning(...args) {
      args.unshift(`${this.name}: `);
      // eslint-disable-next-line no-console
      console.warn.apply(null, args);
    }
  }

  Component.selectors = {
    mobileFlag: '.mobileFlag',
    parentComponentSelector: '.component, .component-fluid, [data-component]'
  };

  return Component;
})(jQuery, window);